import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import config from "../../../configs/config";
import { clearLoggedUserSession, redirectToLogout } from "../../../shared/services/authSessionService";
import { notifyExternalLogout } from "../../../shared/services/externalLogoutService";
import { getLanguageSection } from "../../../shared/services/languageService";
import { buildReserveHotelUrl } from "../../../shared/services/reserveHotelService";
import ReservHotelContactModal from "./ContactModal";
import MultimediaLibraryModal from "./MultimediaLibraryModal";
import { generateTemporalUrlSignature } from "../api/temporalUrlApi";

const Navigation = () => {
  const location = useLocation();
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const language = getLanguageSection("navigation");
  const firstName = Cookies.get("FirstName") || "";
  const countryUser = Cookies.get("CountryUser");
  const currentLanguage = Cookies.get("language");
  const isSpanish = currentLanguage === "esp";
  const brand = process.env.REACT_APP_BRAND;

  const rewardPaths = ["/rewards", "/registerbooking", "/trackredeem", "/detailsfaqs"];
  const isMarivalRewards = rewardPaths.some((path) => location.pathname.indexOf(path) === 0);
  const hiddenMainMenuPaths = ["/rewards", "/registerbooking", "/trackredeem", "/detailsfaqs"];
  const hiddenMainAllMenuPaths = [...hiddenMainMenuPaths, "/webinar"];

  const isMainMenuHidden = hiddenMainAllMenuPaths.some((path) => location.pathname.indexOf(path) === 0);
  const isMainMenuHiddenForRewards = hiddenMainMenuPaths.some((path) => location.pathname.indexOf(path) === 0); 

    const logo = isMainMenuHiddenForRewards
    ? 
     {
      src: "https://marivalrewards.com/img/Marival%C2%AE-Rewards.png",
      alt: "Marival Rewards",
      className: "h-9 w-auto"
    }:
    {
      src: `${config.publicurl}assets/logo/marival-agents.svg`,
      alt: "Marival Resorts for Agents",
      className: "h-10 w-auto"
    };

  const displayName = firstName || "";
  const initials = displayName
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part.charAt(0))
    .join("")
    .toUpperCase() || "PV";

  const menuItems = [
    {
      to: "/rewards",
      label: language.home,
      icon: "home",
      exact: true,
    },
    {
      to: "/registerbooking",
      label: language.registerbooking,
      icon: "mail",
    },
    {
      to: "/trackredeem",
      label: language.track,
      icon: "edit",
    },
    {
      to: "/detailsfaqs",
      label: language.details,
      icon: "chart",
    },
  ];

 
  const topLinks = [
  
   
    { href: isSpanish ? "https://marivalagents.com/es/multimedia" : "https://marivalagents.com/media-library", label: "Media Kit", signed: true },
    { href: isSpanish ? "https://marivalagents.com/es/bodas" : "https://marivalagents.com/weddings", label: isSpanish ? "Bodas" : "Weddings", signed: true },
     { href: isSpanish ? "https://marivalagents.com/blog" : "https://marivalagents.com/blog", label: "Blog" },
     { action: "contact", label: isSpanish ? "Contacto" : "Contact" },
  ];

  const handleSignedLink = async (event, targetUrl) => {
    event.preventDefault();

    // La firma se genera EN EL CLIC (no antes): pedimos la URL firmada y recién
    // entonces abrimos la pestaña nueva. Sin pre-abrir pestañas en blanco.
    try {
      const signedUrl = await generateTemporalUrlSignature(targetUrl);
      window.open(signedUrl, "_blank", "noopener,noreferrer");
    } catch (error) {
      // Si falla la firma, caemos a la URL original para no dejar sin acceso.
      window.open(targetUrl, "_blank", "noopener,noreferrer");
    }
  };

  const selectLanguage = (event) => {
    event.preventDefault();

    const currentLanguage = Cookies.get("language");
    Cookies.set("language", currentLanguage === "eng" ? "esp" : "eng");
    window.location.reload();
  };

  const logout = (event) => {
    event.preventDefault();
    notifyExternalLogout();
    clearLoggedUserSession();
    redirectToLogout();
  };

  const renderIcon = (icon) => {
    if (icon === "home") {
      return (
        <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M4 10.8 12 4l8 6.8V20a1 1 0 0 1-1 1h-5v-6h-4v6H5a1 1 0 0 1-1-1v-9.2Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
        </svg>
      );
    }

    if (icon === "mail") {
      return (
        <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M4 6h16v12H4V6Z" stroke="currentColor" strokeWidth="1.8" />
          <path d="m5 7 7 6 7-6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    }

    if (icon === "edit") {
      return (
        <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="m5 16.5-.8 3.3 3.3-.8L18.8 7.7l-2.5-2.5L5 16.5Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
          <path d="m15.5 6 2.5 2.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
      );
    }

    return (
      <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M5 19V9m7 10V5m7 14v-7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    );
  };

  const renderMenuLink = (item) => (
    <li key={item.to} className="list-none">
      <NavLink
        exact={item.exact}
        to={item.to}
        className="group flex min-h-[58px] items-center gap-4 rounded-xl border border-slate-200 bg-white px-5 py-3 text-sm text-marival-navy shadow-sm transition hover:border-marival-blue hover:text-marival-blue"
        activeClassName="is-active !border-marival-blue !bg-marival-blue !text-white"
      >
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#eaf6fb] text-marival-blue group-[.is-active]:bg-white/20 group-[.is-active]:text-white">
          {renderIcon(item.icon)}
        </span>
        <span>{item.label}</span>
      </NavLink>
    </li>
  );


  const isMainMenuAvailable =
    process.env.REACT_APP_JUST_MARIVAL_REWARDS !== "true" && !isMainMenuHidden;
  const showLanguageToggle = countryUser !== "40";

  const closeMobileMenu = () => setIsMobileMenuOpen(false);

  // Cierra el panel móvil al navegar a otra ruta.
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  const openContactModal = () => {
    closeMobileMenu();
    setIsContactModalOpen(true);
  };

  // Mismos links para desktop y móvil; solo cambia la clase (horizontal vs apilado).
  const renderMainLinks = (linkClassName) => (
    <>
      <NavLink
        exact
        to="/"
        className={linkClassName}
        activeClassName="!text-marival-blue"
        onClick={closeMobileMenu}
      >
        {language.home}
      </NavLink>

      <a
        href="rewards"
        target="_blank"
        rel="noreferrer"
        className={linkClassName}
        onClick={closeMobileMenu}
      >Marival Rewards</a>
      {/* <NavLink
        to="/rewards"
        isActive={() => isMarivalRewards}
        className="text-sm font-bold text-marival-ink hover:text-marival-blue"
        activeClassName="!text-marival-blue"
      >
        Marival Rewards
      </NavLink>
       */}
      <a
        href={buildReserveHotelUrl()}
        target="_blank"
        rel="noreferrer"
        className={linkClassName}
        onClick={closeMobileMenu}
      >
        {language.reservehotel}
      </a>

      <a
        href="webinar"
        target="_blank"
        rel="noreferrer"
        className={linkClassName}
        onClick={closeMobileMenu}
      >{language.webinar}</a>

      {/* <NavLink
        to="/webinar"
        className="text-sm font-bold text-marival-ink hover:text-marival-blue"
        activeClassName="!text-marival-blue"
      >
        {language.webinar}
      </NavLink>
      */}
      {topLinks.map((link) => {
        if (link.action === "contact") {
          return (
            <button
              key={link.label}
              type="button"
              className={`border-0 bg-transparent text-left ${linkClassName}`}
              onClick={openContactModal}
            >
              {link.label}
            </button>
          );
        }

        return (
          <a
            key={link.label}
            href={link.href}
            target="_blank"
            rel="noreferrer"
            onClick={(event) => {
              closeMobileMenu();
              if (link.signed) handleSignedLink(event, link.href);
            }}
            className={linkClassName}
          >
            {link.label}
          </a>
        );
      })}
    </>
  );

  const desktopLinkClassName = "p-0 text-sm font-bold text-marival-ink hover:text-marival-blue";
  const mobileLinkClassName = "block rounded-md bg-slate-50 px-3 py-3 text-sm font-bold text-marival-ink hover:text-marival-blue";

  return (
    <div className="mr-ui bg-marival-soft">
      <div className="sticky top-0 z-[1000] border-b border-slate-200 bg-white shadow-[0_8px_22px_rgba(17,24,63,0.08)]">
        <div className="mx-auto flex min-h-16 w-full max-w-7xl items-center justify-between gap-3 px-5 py-3 md:gap-5 md:px-8">
          <a href="/" className="flex shrink-0 items-center">
            <img src={logo.src} alt={logo.alt} className={logo.className} />
          </a>

          {isMainMenuAvailable ? (
            <nav className="hidden items-center gap-8 md:flex">
              {renderMainLinks(desktopLinkClassName)}
            </nav>
          ) : null}

          <div className="flex items-center gap-2 md:gap-3">
            {showLanguageToggle ? (
              <a href="/" onClick={selectLanguage} className="hidden items-center gap-1 text-sm font-bold text-slate-500 hover:text-marival-blue md:flex">
                <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z" stroke="currentColor" strokeWidth="1.7" />
                  <path d="M3.5 12h17M12 3c2.3 2.3 3.5 5.3 3.5 9s-1.2 6.7-3.5 9c-2.3-2.3-3.5-5.3-3.5-9S9.7 5.3 12 3Z" stroke="currentColor" strokeWidth="1.7" />
                </svg>
                <span>{language.language}</span>
              </a>
            ) : null}

            <div className="group relative hidden md:block">
              <button className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white py-1.5 pl-1.5 pr-3 text-sm font-bold text-marival-ink shadow-sm">
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-marival-navy text-xs font-black text-white">{initials}</span>
                <span className="max-w-[120px] truncate">{displayName}</span>
                <svg className="h-4 w-4 text-slate-400" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="m7 10 5 5 5-5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>

              <div className="invisible absolute right-0 top-full z-[1100] w-64 pt-2 opacity-0 transition group-hover:visible group-hover:opacity-100 group-focus-within:visible group-focus-within:opacity-100">
                <div className="rounded-xl border border-slate-200 bg-white p-3 shadow-marival">
                  <div className="border-b border-slate-100 px-2 pb-3">
                    <div className="font-black text-marival-ink">{displayName}</div>
                  </div>
                  <NavLink to="/restorepasswordmanual" className="mt-2 flex rounded-lg px-2 py-2 text-sm font-bold text-marival-ink hover:bg-slate-50">
                    {language.changepass}
                  </NavLink>
                  <a href="/" onClick={logout} className="flex rounded-lg px-2 py-2 text-sm font-bold text-red-500 hover:bg-red-50">
                    {language.logout}
                  </a>
                </div>
              </div>
            </div>

            <button
              type="button"
              className="inline-flex h-11 w-11 items-center justify-center rounded-md border border-slate-200 bg-white text-marival-ink shadow-sm md:hidden"
              aria-label={isMobileMenuOpen ? "Close navigation menu" : "Open navigation menu"}
              aria-expanded={isMobileMenuOpen}
              aria-controls="private-mobile-menu"
              onClick={() => setIsMobileMenuOpen((current) => !current)}
            >
              {isMobileMenuOpen ? (
                <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="M6 6l12 12M18 6 6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                </svg>
              ) : (
                <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="M4 7h16M4 12h16M4 17h16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                </svg>
              )}
            </button>
          </div>
        </div>

        <div
          id="private-mobile-menu"
          className={`${isMobileMenuOpen ? "block" : "hidden"} border-t border-slate-100 bg-white px-5 py-4 md:hidden`}
        >
          <div className="mx-auto grid max-w-7xl gap-2">
            {isMainMenuAvailable ? (
              <nav className="grid gap-2">
                {renderMainLinks(mobileLinkClassName)}
              </nav>
            ) : null}

            {showLanguageToggle ? (
              <a href="/" onClick={selectLanguage} className={`${mobileLinkClassName} flex items-center gap-2 text-slate-500`}>
                <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z" stroke="currentColor" strokeWidth="1.7" />
                  <path d="M3.5 12h17M12 3c2.3 2.3 3.5 5.3 3.5 9s-1.2 6.7-3.5 9c-2.3-2.3-3.5-5.3-3.5-9S9.7 5.3 12 3Z" stroke="currentColor" strokeWidth="1.7" />
                </svg>
                <span>{language.language}</span>
              </a>
            ) : null}

            <div className="mt-2 border-t border-slate-100 pt-3">
              <div className="flex items-center gap-3 px-3 pb-2">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-marival-navy text-xs font-black text-white">{initials}</span>
                <span className="truncate font-black text-marival-ink">{displayName}</span>
              </div>
              <NavLink to="/restorepasswordmanual" className={mobileLinkClassName} onClick={closeMobileMenu}>
                {language.changepass}
              </NavLink>
              <a href="/" onClick={logout} className={`${mobileLinkClassName} mt-2 !text-red-500 hover:bg-red-50`}>
                {language.logout}
              </a>
            </div>
          </div>
        </div>
      </div>

      <section className="bg-marival-navy text-white">
        <div className="mx-auto w-full max-w-7xl px-5 pt-8 md:px-8">
          <div className="flex items-center gap-4 pb-7">
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-white/20 bg-white/10 text-sm font-black">
              {initials}
            </div>
            <h1 className="m-0 text-2xl font-black md:text-3xl">
              {language.welcome} {displayName}
            </h1>
          </div>
        </div>
      </section>

      {isMarivalRewards || process.env.REACT_APP_JUST_MARIVAL_REWARDS === "true" ? (
        <div className="mx-auto w-full max-w-7xl px-5 py-6 md:px-8">
          <ul className="m-0 grid list-none gap-4 p-0 md:grid-cols-2 lg:grid-cols-4">
            {menuItems.map((item) => renderMenuLink(item))}
          </ul>
        </div>
      ) : null}

      <ReservHotelContactModal
        isOpen={isContactModalOpen}
        onClose={() => setIsContactModalOpen(false)}
        title={isSpanish ? "Contacto" : "Contact"}
      />

      <MultimediaLibraryModal />
    </div>
  );
};

export default Navigation;
